import { Spinner } from './Spinner';
import styles from './LoadMoreButton.module.css';

type LoadMoreButtonProps = {
  readonly onClick: () => void;
  readonly isLoading: boolean;
  readonly hasMore: boolean;
  readonly testId?: string;
};

const LoadMoreButton = ({ onClick, isLoading, hasMore, testId }: LoadMoreButtonProps): React.ReactElement | null => {
  if (!hasMore) return null;

  return (
    <div className={styles.container}>
      <button
        type="button"
        data-testid={testId ?? 'loadmore'}
        className={styles.button}
        onClick={onClick}
        disabled={isLoading}
      >
        {isLoading ? <Spinner /> : 'Load more'}
      </button>
    </div>
  );
};

export { LoadMoreButton };
export type { LoadMoreButtonProps };
